/**
 * @generated SignedSource<<ef2438ef6aecb28aab7cfb0647910fe4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Report_reportable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Reportable",
  "abstractKey": "__isReportable"
};

node.hash = "0f327a42be8a66308d3fe59e73f7581d";

module.exports = node;
